import { render, staticRenderFns } from "./BlankComponent.vue?vue&type=template&id=25921425&scoped=true&"
import script from "./BlankComponent.vue?vue&type=script&lang=js&"
export * from "./BlankComponent.vue?vue&type=script&lang=js&"
import style0 from "./BlankComponent.vue?vue&type=style&index=0&id=25921425&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25921425",
  null
  
)

export default component.exports